export default "__VITE_ASSET__AD9CQ6He__"